import React, { useState, useEffect } from "react";
import "../product/product.css";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "react-bootstrap/Modal";
import Edit from "./Edit";
import EditDrawer from "../product/Drawer";
import AddDrawer from "../product/AddDrawer";
import Pagination from "react-bootstrap/Pagination";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext"; 

function Product() {
  const { isLoggedIn } = useAuth();

  // ✅ All hooks must be at the top
  const [products, setProducts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectProduct, setSelectProduct] = useState(null);
  const [showDrawer, setShowDrawer] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  useEffect(() => {
    fetch("https://fakestoreapi.com/products")
      .then((response) => response.json())
      .then((data) => setProducts(data))
      .catch((err) => console.error("Error fetching products:", err));
  }, []);

  // ✅ Only after all hooks, return if not logged in
  if (!isLoggedIn) return <Navigate to="/login" />;

  const handleDelete = (id) => {
    const updatedProducts = products.filter((product) => product.id !== id);
    setProducts(updatedProducts);
    toast.success("Item Deleted Successfully!❌");
  };

  const handleEditProduct = (product) => {
    setSelectProduct(product);
    setShowDrawer(true);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = products.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div>
      <ToastContainer />

      <div className="head-pro">
        <h1>All Products</h1>
        <button onClick={() => setShowModal(true)}>
          <a href="#">ADD PRODUCT</a>
        </button>
      </div>

      {/* Add Product Drawer */}
      <AddDrawer
        open={showModal}
        onClose={() => setShowModal(false)}
        products={products}
        setProducts={setProducts}
      />

      {/* Product Cards */}
      <div className="body">
        <div className="product-list">
          {currentItems.map((item) => (
            <div key={item.id} className="card-wrapper">
              <Card style={{ width: "100%" }}>
                <Card.Title>{item.title.slice(0, 20)}...</Card.Title>
                <Card.Img variant="top" src={item.image} />

                <Card.Body>
                  <Card.Text>{item.description.slice(0, 40)}....</Card.Text>
                  <Card.Text
                    style={{
                      color: "green",
                      fontWeight: "bold",
                      fontSize: "1.8rem",
                    }}
                  >
                    ₹ {item.price}
                  </Card.Text>
                </Card.Body>
              </Card>

              <div className="view-button">
                <Link to={`/view/${item.id}`}>
                  <Button variant="primary">View Product</Button>
                </Link>
              </div>

              <div className="action-button">
                <Button variant="danger" onClick={() => handleDelete(item.id)}>
                  Delete
                </Button>
                <Button
                  variant="warning"
                  onClick={() => handleEditProduct(item)}
                >
                  Edit
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Pagination */}
      <div className="d-flex justify-content-center mt-4">
        <Pagination>
          <Pagination.Prev
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            &laquo;
          </Pagination.Prev>

          {[...Array(Math.ceil(products.length / itemsPerPage)).keys()].map(
            (number) => (
              <Pagination.Item
                key={number + 1}
                active={number + 1 === currentPage}
                onClick={() => setCurrentPage(number + 1)}
              >
                {number + 1}
              </Pagination.Item>
            )
          )}

          <Pagination.Next
            onClick={() =>
              setCurrentPage((prev) =>
                prev < Math.ceil(products.length / itemsPerPage)
                  ? prev + 1
                  : prev
              )
            }
            disabled={currentPage === Math.ceil(products.length / itemsPerPage)}
          >
            &raquo;
          </Pagination.Next>
        </Pagination>
      </div>

      {/* Edit Product Drawer */}
      <EditDrawer
        open={showDrawer}
        onClose={() => setShowDrawer(false)}
        product={selectProduct}
        setproduct={setProducts}
      />
    </div>
  );
}

export default Product;

